import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";
import { FileText, Download, Mail } from "lucide-react";

const PressPage = () => {
  const releases = [
    {
      date: "15 Haziran 2026",
      title: "Verasist, 500+ Müşteriye Ulaştı",
      summary: "Sesli AI ajan platformu Verasist, 500'den fazla işletmeye hizmet vermeye başladı. Bankacılık, e-ticaret ve sağlık sektörleri başı çekiyor.",
      tag: "Kilometre Taşı",
    },
    {
      date: "3 Mayıs 2026",
      title: "Microsoft Dynamics 365 Entegrasyonu Yayında",
      summary: "Verasist, Microsoft Dynamics 365 ile tam entegrasyon desteğini duyurdu. Bu sayede Dynamics 365 kullanan işletmeler sesli AI ajanlarını CRM'leriyle sorunsuz entegre edebilecek.",
      tag: "Ürün",
    },
    {
      date: "12 Mart 2026",
      title: "Verasist, Seed Yatırım Turunu Tamamladı",
      summary: "Yapay zeka odaklı girişim sermayesi fonlarından aldığı yatırımla büyümesini hızlandıran Verasist, uluslararası pazarlara açılma planlarını duyurdu.",
      tag: "Yatırım",
    },
    {
      date: "20 Ocak 2026",
      title: "30+ Dil Desteği ile Globalleşme Adımı",
      summary: "Verasist platformu, Türkçe ve İngilizce'nin yanı sıra artık 30'dan fazla dilde sesli AI ajanı desteği sunuyor. Almanca, Fransızca, Arapça ve İspanyolca ilk sırada.",
      tag: "Ürün",
    },
    {
      date: "5 Kasım 2025",
      title: "Verasist, Webrazzi Summit 2025'te Sahne Aldı",
      summary: "Kurucu ortaklarımız, Webrazzi Summit 2025'te 'Sesli AI ile Müşteri Deneyiminin Geleceği' başlıklı bir sunum gerçekleştirdi.",
      tag: "Etkinlik",
    },
  ];

  const hero = (
    <PageHero
      eyebrow="Basın"
      title="Basın Odası"
      subtitle="Verasist hakkındaki en güncel haberler, basın bültenleri ve medya kaynakları."
    />
  );

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/images/pages/press-conference.jpg" alt="Basın toplantısı" height="340px" />
      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-wrap items-center justify-between gap-4 mb-10">
              <h2 className="text-[28px] font-bold" style={{ color: "var(--fg)" }}>Basın Bültenleri</h2>
              <div className="flex gap-3">
                <a
                  href="mailto:press@verasist.ai"
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-[13px] font-medium transition-colors duration-200"
                  style={{ background: "var(--card-bg)", border: "1px solid var(--border)", color: "var(--fg)" }}
                >
                  <Mail size={14} /> Medya İletişim
                </a>
              </div>
            </div>
            <div className="space-y-4">
              {releases.map((r) => (
                <div
                  key={r.title}
                  className="p-6 rounded-2xl transition-colors duration-200"
                  style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}
                >
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-[11px] font-medium" style={{ color: "var(--muted)" }}>{r.date}</span>
                    <span
                      className="text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full"
                      style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}
                    >
                      {r.tag}
                    </span>
                  </div>
                  <h3 className="text-[17px] font-semibold mb-2" style={{ color: "var(--fg)" }}>{r.title}</h3>
                  <p className="text-[14px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.82 }}>{r.summary}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-[28px] font-bold mb-4" style={{ color: "var(--fg)" }}>Medya Kiti</h2>
            <p className="text-[15px] mb-8" style={{ color: "var(--fg)", opacity: 0.85 }}>
              Logo, kurucu fotoğrafları, ürün ekran görüntüleri ve marka kılavuzunu içeren medya kitimizi indirebilirsiniz.
            </p>
            <a
              href="mailto:press@verasist.ai"
              className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-semibold text-[14px] transition-all duration-200"
              style={{ background: "var(--brand-navy)", color: "#fff" }}
            >
              <Download size={16} /> Medya Kiti İsteyin
            </a>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default PressPage;
